import { useTranslation } from "@/hooks/useTranslation";
import { useGetAllBuyers } from "@/services";
import { Button, Icon, SmartSelect } from "@st-marketplace/ui";

export default function BuyerSelect({
	id,
	value,
	onChange,
	disabled,
}: {
	id: string;
	value: string;
	onChange: (relationId: string) => void;
	disabled: boolean;
}) {
	const { t } = useTranslation();
	const { data, isLoading, error, refetch } = useGetAllBuyers({});
	return (
		<div
			id={id}
			role="group"
			aria-labelledby={`${id}-label`}
			className="space-y-2"
		>
			<SmartSelect
				className="w-full"
				hasTitlePrefix
				items={(data ?? []).map((buyer) => ({
					value: buyer.relation_id,
					label: buyer.name,
					disabled,
				}))}
				value={value}
				onChange={(relationId) => {
					if (!disabled) onChange(relationId);
				}}
				searchable
				loading={isLoading}
				leadingIcon={<Icon name="user-line" />}
				placeholder={t("addOrder.chooseBuyer")}
				searchPlaceholder={t("addOrder.searchBuyer")}
				popoverProps={{
					className: "w-[var(--radix-popover-trigger-width)] max-w-none p-0",
				}}
			/>
			{error ? (
				<Button
					type="button"
					color="secondary"
					size="sm"
					onClick={() => refetch()}
				>
					{t("error.tryAgain")}
				</Button>
			) : !isLoading && !data?.length ? (
				<p className="text-sm text-secondary-text">{t("addOrder.noBuyers")}</p>
			) : null}
		</div>
	);
}
